import { render, staticRenderFns } from "./noFormat.vue?vue&type=template&id=5cbf1f7d&"
import script from "./noFormat.vue?vue&type=script&lang=js&"
export * from "./noFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/noFormat.vue
// module id = 1612
// module chunks = 0